import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const SvgQuestion = ({ className, ...props }) => {
  const classes = classNames({
    svg: true,
    'svg-question': true,
    [className]: className,
  });

  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      width="16"
      height="16"
      className={classes}
      {...props}>
      <path
        fillRule="evenodd"
        d="M 0 7.99939 C 0 3.58374 3.58203 0 8 0 C 12.4141 0 16 3.58374 16 7.99939 C 16 12.415 12.4141 15.9988 8 15.9988 C 3.58203 15.9988 0 12.415 0 7.99939 Z M 8.80469 11.1992 L 8.80469 12.7991 L 7.20312 12.7991 L 7.20312 11.1992 L 8.80469 11.1992 Z M 7.99609 14.399 C 4.46875 14.399 1.59766 11.5272 1.59766 7.99945 C 1.59766 4.47174 4.46875 1.59998 7.99609 1.59998 C 11.5234 1.59998 14.3984 4.47174 14.3984 7.99945 C 14.3984 11.5272 11.5234 14.399 7.99609 14.399 Z M 4.80469 6.39948 C 4.80469 4.63159 6.23828 3.19971 8.00391 3.19971 C 9.77344 3.19971 11.2031 4.63159 11.2031 6.39948 C 11.2031 7.42572 10.5703 7.97797 9.95703 8.51575 C 9.375 9.02588 8.80469 9.52295 8.80469 10.3992 L 7.20312 10.3992 C 7.20312 8.94226 7.95703 8.36456 8.62109 7.85669 C 9.14062 7.45825 9.60547 7.10278 9.60547 6.39948 C 9.60547 5.51953 8.88281 4.79956 8.00391 4.79956 C 7.125 4.79956 6.40625 5.51953 6.40625 6.39948 L 4.80469 6.39948 Z"
      />
    </svg>
  );
};

SvgQuestion.propTypes = {
  className: PropTypes.string,
};

export default SvgQuestion;
